module.exports = __webpack_public_path__ + "pintora/delayed-a0822a03345789f4.svg";